import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0C15.089 0 6.525 5.768 2.481 14.13h45.038C43.475 5.768 34.911 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50c9.911 0 18.475-5.768 22.52-14.13H2.48C6.525 44.232 15.089 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "m31.148 17.764-2.305 2.305a5.435 5.435 0 1 1-7.686 0l-2.306-2.305a8.696 8.696 0 1 0 12.297 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 20.653.809 2.491h2.619l-2.119 1.54.81 2.49-2.12-1.539-2.119 1.54.81-2.491-2.12-1.54h2.62l.81-2.491Z"
}));
FlagPY.displayName = 'FlagPY';
export default withFlagWrapper(FlagPY);
//# sourceMappingURL=index.js.map